import { motion } from "framer-motion";
import { PHOTO_LIBRARY } from "../../data/photoLibrary";

const ease = [0.22, 1, 0.36, 1];

const STEPS = [
  {
    no: "01",
    label: "Consultation",
    copy: "Your vision, sketched over fabric swatches and the lookbook.",
    img: PHOTO_LIBRARY.consultationLookbook.url,
    pos: "object-center",
    testid: "atelier-card-consultation",
  },
  {
    no: "02",
    label: "Measure & Fit",
    copy: "Every measurement taken and refined by hand for a flawless fit.",
    img: PHOTO_LIBRARY.measuringBrideCamel.url,
    pos: "object-center",
    testid: "atelier-card-measuring",
  },
  {
    no: "03",
    label: "Steam & Finish",
    copy: "Final pressing and finishing touches, ready for the aisle.",
    img: PHOTO_LIBRARY.heroSteamingPinkFitted.url,
    pos: "object-center",
    testid: "atelier-card-steaming",
  },
];

export const AtelierDay = () => (
  <section className="py-24 md:py-40 bg-stone" data-testid="atelier-band">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <div className="md:flex md:items-end md:justify-between mb-14 md:mb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
        >
          <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-5">Behind the seams</p>
          <h2 className="font-serif font-normal text-5xl md:text-6xl leading-[0.95] tracking-tight">
            A day in the <span className="italic">atelier</span>
          </h2>
        </motion.div>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease }}
          className="mt-6 md:mt-0 md:max-w-sm text-base md:text-lg font-light text-ink/70 leading-relaxed"
        >
          From first sketch to final press, every gown is shaped by Nancy's own hands — a private,
          unhurried process from start to finish.
        </motion.p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 md:gap-8">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.no}
            data-testid={s.testid}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.12, ease }}
            className="group"
          >
            <div className="relative overflow-hidden aspect-[3/4] border border-line bg-ivory">
              <img
                src={s.img}
                alt={`Nancy — ${s.label}`}
                className={`img-zoom w-full h-full object-cover ${s.pos}`}
              />
              <span className="absolute top-4 left-4 font-serif text-ivory text-3xl md:text-4xl drop-shadow-[0_1px_6px_rgba(0,0,0,0.45)]">
                {s.no}
              </span>
            </div>
            <div className="mt-5 flex items-baseline justify-between border-t border-line pt-4">
              <h3 className="font-serif text-2xl md:text-3xl tracking-tight">{s.label}</h3>
            </div>
            <p className="mt-2 text-ink/70 font-light leading-relaxed text-sm md:text-base">{s.copy}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
